import script from "./NoteSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteSearch.vue?vue&type=script&setup=true&lang=js"

import "./NoteSearch.vue?vue&type=style&index=0&id=0ffafc7e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffafc7e"]])

export default __exports__